export default {
  'any.empty': 'Not allowed to be empty',
  'string.email': 'Must be a valid email',
  'string.max': 'Value is too long',
};
